var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTestdata = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 86,
    viewBox: "0 0 89 86",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.25 47.3568C84.25 28.4694 68.9374 13.1568 50.05 13.1568C31.1626 13.1568 15.85 28.4694 15.85 47.3568C15.85 66.2442 31.1626 81.5568 50.05 81.5568C68.9374 81.5568 84.25 66.2442 84.25 47.3568Z",
    fill: "#D0EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3 47.3568C88.3 26.232 71.1748 9.10684 50.05 9.10684C28.9252 9.10684 11.8 26.232 11.8 47.3568C11.8 68.4816 28.9252 85.6068 50.05 85.6068C71.1748 85.6068 88.3 68.4816 88.3 47.3568Z",
    stroke: "#A4B8D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.91 4.55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1 43.0818C72.1 28.5432 60.3136 16.7568 45.775 16.7568C31.2364 16.7568 19.45 28.5432 19.45 43.0818C19.45 57.6204 31.2364 69.4068 45.775 69.4068C60.3136 69.4068 72.1 57.6204 72.1 43.0818Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9258 23.7977V10.3733V9.13763C61.9258 4.89143 58.4842 1.44983 54.238 1.44983H9.13806C13.3834 1.44983 16.8259 4.89143 16.8259 9.13763V63.9764C16.8259 68.2217 20.2675 71.6642 24.5128 71.6642H69.6136C65.3674 71.6642 61.9258 68.2217 61.9258 63.9764V56.3066",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13775 1.44983C4.89155 1.44983 1.44995 4.89143 1.44995 9.13763V13.7501H16.8256",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2131 12.0309H25.9557",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2131 17.4951H25.9557",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2131 22.9602H25.9557",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0697 28.4243H25.9557",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3216 51.4525C57.991 52.9078 51.6793 48.9559 50.224 42.6253C48.7696 36.2947 52.7206 29.9839 59.0512 28.5277C65.3818 27.0724 71.6926 31.0252 73.1488 37.3549C74.6041 43.6855 70.6513 49.9972 64.3216 51.4525Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7825 33.8911H25.9553",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 47.3067V61.1757H46.45",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5513 52.1609V57.5672",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8027 53.5452V57.5673",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0328 49.4873V57.5675",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3001 55.1765V57.5669",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6868 28.2292V39.7069L69.8516 31.5412",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6858 39.7068L69.9514 48.3576",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4758 23.3477V9.92332V8.68762C61.4758 4.44142 58.0342 0.999817 53.788 0.999817H8.68811C12.9334 0.999817 16.3759 4.44142 16.3759 8.68762V63.5264C16.3759 67.7717 19.8175 71.2142 24.0628 71.2142H69.1636C64.9174 71.2142 61.4758 67.7717 61.4758 63.5264V55.8566",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6878 0.999817C4.4416 0.999817 1 4.44142 1 8.68762V13.3001H16.3756",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7631 11.581H25.5057",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7631 17.0451H25.5057",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7631 22.5102H25.5057",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6196 27.9744H25.5056",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8717 51.0026C57.5411 52.4579 51.2294 48.506 49.7741 42.1754C48.3197 35.8448 52.2707 29.534 58.6013 28.0778C64.9319 26.6225 71.2427 30.5753 72.6989 36.905C74.1542 43.2356 70.2014 49.5473 63.8717 51.0026Z",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3324 33.4411H25.5052",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 46.8567V60.7257H46",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1014 51.7109V57.1172",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3526 53.0952V57.1173",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5828 49.0373V57.1175",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8501 54.7265V57.1169",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2367 27.7792V39.2569L69.4015 31.0912",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 39.2568L69.5014 47.9076",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTestdata, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/testdata.f69f291e.svg";
export { ForwardRef as ReactComponent };